import baseService from '@common/services/base.service';
import store from '@common/store/store';

const accessControlRoute = window.api_routes.smarAPD_AccessControl_Domain;
const authRoute = window.api_routes.smarAPD_Authorization_Domain;
const commonRoute = window.api_routes.smarAPD_Common;

const defaultAuthHeaders = {
  Accept: 'application/json; version=2.0',
};

let http = baseService(store);

const apidDef = {
  accessControl: {
    getSystemsByUser({ user }) {
      return http.get(`${accessControlRoute}/Usuario/${user}/Sistemas`);
    },
    getFuncionalidadeByUrl({ url, sistema }) {
      return http.get(
        `${accessControlRoute}/Funcionalidade/Url/?urlEncoded=${encodeURIComponent(url)}&sistema=${sistema}`
      );
    },
    getPermissions({ user, onlyClientSidePermissions }) {
      return http.get(`${accessControlRoute}/Usuario/${user}/Permissao`, {
        params: { onlyClientSidePermissions: onlyClientSidePermissions },
      });
    },
  },
  /**
   * @deprecated Os métodos de `auth` estão obsoleto pela adequação de usuários internos e externos
   * Utilize `authorization` para nova implementação com total separação entre usuários internos e externos
   */
  auth: {
    getLastAccessByUser({ user }) {
      return http.get(`${authRoute}/HistoricoAcesso/${user}`);
    },
    updateUserTheme(user, theme) {
      return http.put(`${authRoute}/Usuario/${user}/SystemTheme`, {
        TemaSistema: theme,
      });
    },
    updatePassword(password) {
      return http.post(`${authRoute}/Usuario/Senha/New`, password);
    },
  },
  authorization: {
    getLastAccessByUser({ user }) {
      return http.get(`${authRoute}/HistoricoAcesso/${user}`);
    },
    updateUserTheme(theme) {
      return http.put(`${authRoute}/usuario/tema`, { Tema: theme }, { headers: defaultAuthHeaders });
    },
    updatePassword(password) {
      return http.put(`${authRoute}/usuario/senha`, password, { headers: defaultAuthHeaders });
    },
    logout(refreshToken) {
      return http.post(`${authRoute}/oauth/revoke`, { RefreshToken: refreshToken }, { headers: defaultAuthHeaders });
    },
  },
  common: {
    getFavoriteByUserSystem({ user, sistema }) {
      return http.get(`${commonRoute}/Usuario/${user}/Sistema/${sistema}/Favoritos/`);
    },

    saveFavorite({ dto, user }) {
      return http.post(`${commonRoute}/Usuario/${user}/Sistema/${dto.IdSistema}/Favoritos`, dto);
    },

    removeFavorite({ user, idFavorito }) {
      return http.delete(`${commonRoute}/Usuario/${user}/Favoritos/${idFavorito}`);
    },

    getNotificationTotalNumber({ system }) {
      return http.get(`${commonRoute}/Notificacao/Atualizar/${system}`);
    },

    getNotificationPage({ page, size, system }) {
      return http.get(`${commonRoute}/Notificacao/Paginacao/${page}/${size}/${system}`, {
        params: { noLoading: true },
      });
    },

    getNotificationTotalByPage({ page, size, system }) {
      return http.get(`${commonRoute}/Notificacao/Total/${page}/${size}/${system}`);
    },

    getNotification(idSistema) {
      return http.get(`${commonRoute}/Notificacao/${idSistema}`);
    },

    readNotification(id) {
      return http.put(`${commonRoute}/notificacao/marcarcomolido/${id}`);
    },

    unreadNotification(id) {
      return http.put(`${commonRoute}/notificacao/MarcarComoNaoLido/${id}`);
    },

    readAllNotification(id) {
      return http.put(`${commonRoute}/notificacao/MarcarTodosComoLido/${id}`);
    },

    deleteNotification(id) {
      return http.delete(`${commonRoute}/notificacao/excluir/${id}`);
    },

    getInfoAbout(idSistema) {
      return http.get(`${commonRoute}/InformacoesSistema/${idSistema}`);
    },
  },
};

export default apidDef;
